import Model from "./base/model";

class BillingContractedPrice extends Model{
  resourceName() {
    return "billing_contracted_prices";
  }

  fields() {
    return {
      minimum_price: "",
      solicitation_ftl_quantity: "",
      solicitation_ftl_price: "",
      solicitation_others_quantity: "",
      solicitation_others_price: "",
    }
  }
}

export default new BillingContractedPrice();
